import PaymentB2CDetails from "../../components/NewDesign/Payment/PaymentB2CDetails"
import PaymentOutlinePage from "../../components/PaymentOutlinePage"

const PaymentSummaryB2CPage = () => {

    return (
        <PaymentOutlinePage>
            <PaymentB2CDetails />
        </PaymentOutlinePage>
    )
}

export default PaymentSummaryB2CPage